export enum CalculationStepAdditionalActionEnum {
  ShowSummary = 'showSummary',
  SaveYourCalculation = 'saveYourCalculation',
  InTestCalculationGoSummary = 'inTestCalculationGoSummary',
}
